var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_210_1",
    "data-name": "Component 210 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.507,
    height: 41.572,
    viewBox: "0 0 41.507 41.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38446",
    "data-name": "Path 38446",
    d: "M1467.144-279.789a18.447,18.447,0,0,1,14.377,4.518,15.673,15.673,0,0,1,4.191,5.268c3.262,6.136,2.911,12.416-.3,18.481-2.466,4.656-8.8,8.97-14.355,9.265-21.848,1.16-28.076-25.674-11.159-35.325a18.13,18.13,0,0,1,7.247-2.208Zm-1.177-1.776a33.585,33.585,0,0,0-4.093,1.054,19.287,19.287,0,0,0-5.069,2.742,15.666,15.666,0,0,0-1.4,1.147,17.84,17.84,0,0,0-2.581,2.691,19.989,19.989,0,0,0-3.554,6.8,20.542,20.542,0,0,0-.682,9.16c1.142,10,11.587,19.461,23.44,17.433a20.348,20.348,0,0,0,13.226-7.5c2.906-3.361,5.466-10.106,4.371-16.038-1.572-8.516-6.758-14.375-14.326-16.779-2.339-.743-6.721-1.345-9.331-.709Z",
    transform: "translate(-1448.376 281.832)",
    fill: "#404040",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38447",
    "data-name": "Path 38447",
    d: "M1481.526-242.921c1.627,0-1.415-8.612,2.554-8.6,3.541.012.7,8.6,2.354,8.6,3.7,0,3.194.268,3.161-1.568-.031-1.749.09-4.533-.072-6-.551-4.969-4.387-5.208-7.52-2.958l-.242-1.045-3.328-.033a43.92,43.92,0,0,0-.108,6.027c0,6.566-.831,5.572,3.2,5.572Z",
    transform: "translate(-1459.763 271.533)",
    fill: "#404040",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38448",
    "data-name": "Path 38448",
    d: "M1468.945-243.231c0,.749,1.123.485,1.937.488.772,0,1.724.236,1.724-.488,0-2.062.155-9.627-.117-11.087l-3.455-.034c-.207,2.192-.089,8.523-.089,11.121Z",
    transform: "translate(-1456.202 271.359)",
    fill: "#404040",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38449",
    "data-name": "Path 38449",
    d: "M1472.738-261.441c0-2.778-4.206-2.709-4.218,0s4.218,2.822,4.218,0Z",
    transform: "translate(-1456.053 274.844)",
    fill: "#404040",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlack);
export default __webpack_public_path__ + "static/media/linkedInBlack.609697561980c5d0b50a915853d9d025.svg";
export { ForwardRef as ReactComponent };